import { Textarea } from '@chakra-ui/react'

Textarea.defaultProps = {
  bg: 'light',
  rounded: 'md',
}
